<template>
  <div id="wrapper" class="bg-white">
    <div id="chart-line2">
      <apexchart
        type="line"
        height="230"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
    <div id="chart-line">
      <apexchart
        type="bar"
        height="130"
        :options="chartOptionsLine"
        :series="seriesLine"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import { utclocaliso } from '@/utils/utils'
import VueApexCharts from "vue-apexcharts"
import { getUnixTime } from 'date-fns'
import { mapActions, mapGetters } from 'vuex'
import dayjs from 'dayjs'
import toObject from 'dayjs/plugin/toObject'
dayjs.extend(toObject)
export default {
  name: "production-chart",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    devid: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.fetchCounts()
  },
  watch: {
    devid(newValue, oldValue) {
      if(newValue !== oldValue){
        this.series = []
        this.seriesLine = []
        console.log('watch prod.chart -> devid')
        this.fetchCounts()
        this.$forceUpdate()
      }
    },
    start(newValue, oldValue) {
      if(newValue !== oldValue){
        console.log('start')
        this.fetchCounts()
        this.$children[1].updateOptions({
          chart: {
            selection: {
              xaxis: {
                min: new Date(Number(newValue) * 1000).getTime(),
                max: new Date(Number(this.end) * 1000).getTime(),
              }
            }
          }
        })
      }
    },
    end(newValue, oldValue) {
      if(newValue !== oldValue){
        console.log('end')
        this.fetchCounts()
        this.$children[1].updateOptions({
          chart: {
            selection: {
              xaxis: {
                min: new Date(Number(this.start) * 1000).getTime(),
                max: new Date(Number(newValue) * 1000).getTime(),
              }
            }
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters(['counts', 'innerStart', 'innerEnd']),
    start() {
      return getUnixTime(this.innerStart)
    },
    end() {
      return getUnixTime(this.innerEnd)
    }
  },
  methods: {
    ...mapActions(['getCounts']),
    async fetchCounts() {
      console.log('fetchCounts')
      await this.getCounts({ 'devid': this.devid, 'freq': 'minute', 'start': this.start, 'end': this.end})
      await this.getCounts({ 'devid': this.devid, 'freq': 'hour', 'start': this.start, 'end': this.end})
      const response = await this.$http.get(`assigns?devid=${this.devid}&start=${this.start}&end=${this.end}`)
      this.assigns = response.data.assigns.map( item => (
        {
          start: new Date(item.start + 'Z').getTime(),
          end: new Date(item.end + 'Z').getTime(),
          vprem: item.vpremiada
        }
      ))
      let assigns = response.data.assigns.map((val) => {
        return {
          x: new Date(val.start + 'Z').getTime(),
          y: val.vmax,
          p: val.product,
          l: val.lote,
          vnom: val.vmax,
        }
      })

      // Add product to minute count
      let counts = this.counts.minute.map((count) => {
        let p = assigns.filter((assign) => {
          return utclocaliso(assign.x) < utclocaliso(count.x)
        })
        var prod
        var vnom
        var lote
        if (p[p.length - 1] === undefined) {
          prod = ''
          lote = ''
          vnom = ''
        } else {
          prod = p[p.length - 1].p
          lote = p[p.length - 1].l
          vnom = p[p.length - 1].vnom
        }
        return {
          x: count.x,
          y: count.y,
          p: prod,
          l: lote,
          vnom: vnom
        }
      })

      assigns.push({
        x: counts[counts.length - 1].x,
        y: assigns[assigns.length - 1].y,
        p: assigns[assigns.length - 1].p,
        l: assigns[assigns.length - 1].l,
        vnom: assigns[assigns.length - 1].vnom
      })


      let countsHour = this.counts.hour.map( h => {
          let vprem = ''
          for (const item of this.assigns){
            if (h.x > item.start && h.x < item.end){
              vprem = item.vprem
            }
          }
          return {
            x: h.x,
            y: h.y,
            vprem: vprem
          }
        }
      )
      this.series = [
        { name: this.$i18n.t('message.productionchart.velocidad'), type: 'line', data: counts },
        { name: this.$i18n.t('message.productionchart.vnominal'), type: 'line', data: assigns },
      ]
      this.seriesLine = [{ name: this.$i18n.t('message.productionchart.produccionhora'), data: countsHour }]
    },
  },
  data() {
    return {
      assigns: [],
      series: [{
          name: "Cuentas",
          data: []
      }],
      chartOptions: {
        chart: {
          id: "chart2", // Gráfico Producción por Minuto
          type: "line",
          height: 200,

          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        colors: ["#253A92", "#DB4437"],
        stroke: {
          curve: ['straight', 'stepline'],
          width: 2
        },
        fill: {
          opacity: 1
        },
        markers: {
          size: 0
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          decimalsInFloat: 2,
          title: {
            text: this.$store.getters.currentDevice.unit
          }
        },
        tooltip: {
          enabled: true,
          custom: ({series, seriesIndex, dataPointIndex, w}) => {
            let dt = w.globals.seriesX[seriesIndex][dataPointIndex]
            const dtf = dayjs(dt).format('DD/MM/YYYY HH:mm:ss')
            const val = series[seriesIndex][dataPointIndex]
            const prod = this.series[seriesIndex].data[dataPointIndex].p
            const lote = this.series[seriesIndex].data[dataPointIndex].l
            const vnom = this.series[seriesIndex].data[dataPointIndex].vnom
            return '<div class="p-1 text-xs">' +
              `<p><b>${dtf}</b> / V: ${val} / Vnom: ${vnom}</p>
               ${lote} - ${prod}
              </div>`
          },
          fixed: {
            enabled: true,
            position: 'topLeft',
            offsetX: 70
          }
        }
      },

      seriesLine: [
        {
          data: []
        }
      ],
      chartOptionsLine: {
        chart: {
          id: "chart1", // Gráfico Producción por Hora
          height: 60,
          type: "column",
          selection: {
            enabled: false,
          },
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          },
        },
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "100%"
          }
        },
        colors: [function({ value, dataPointIndex, w}) {
          if (w.globals.initialSeries[0].data.length === 0){
            return ""
          }
          if (value >= w.globals.initialSeries[0].data[dataPointIndex].vprem) {
            return "#68D138"
          }
          else {
            return "#D93D39"
          }
        }],
        xaxis: {
          type: "datetime",
          tooltip: {
            enabled: false
          },
          labels: {
            datetimeUTC: false
          }
        },
        legend: {
          show: false
        },
        yaxis: {
          tickAmount: 2,
          decimalsInFloat: 2,
          title: {
            text: this.$store.getters.currentDevice.unit
          }
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"]
        }
      }

    };
  }
};
</script>
